import { render, staticRenderFns } from "./emptyPage.vue?vue&type=template&id=51c38552&scoped=true"
import script from "./emptyPage.vue?vue&type=script&lang=js"
export * from "./emptyPage.vue?vue&type=script&lang=js"
import style0 from "./emptyPage.vue?vue&type=style&index=0&id=51c38552&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c38552",
  null
  
)

export default component.exports